import React, {Component} from 'react';

class EmailPreview extends Component {

    render() {
        return (
            <div
                className="modal fade in"
                id="AddCourseModal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="myModalLabel"
                style={{display: 'block'}}
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span
                                    aria-hidden="true"
                                    onClick={this.props.onCloseModal}
                                >
                                    ×
                                </span>
                            </button>
                            <h4 className="modal-title" id="myModalLabel">Your email preview:</h4>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <div
                                            dangerouslySetInnerHTML={{__html: this.props.content}} //DANGER OF XSS
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-default"
                                data-dismiss="modal"
                                onClick={this.props.onCloseModal}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}

export default EmailPreview;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/People/EmailPreview.js